import script from "./WidgetForm.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetForm.vue?vue&type=script&setup=true&lang=js"

import "./WidgetForm.vue?vue&type=style&index=0&id=18fee158&lang=css"

const __exports__ = script;

export default __exports__